export const ADD_TRANSLATION = 'productPhraseTRForm/ADD_TRANSLATION';
export const SAVE_BUTTON_CLICK = 'productPhraseTRForm/SAVE_BUTTON_CLICK';
export const LOAD_FORM = 'productPhraseTRForm/LOAD_FORM';
export const DELETE_BUTTON_CLICK = 'productPhraseTRForm/DELETE_BUTTON_CLICK';
